/* KOMTO redesign (BAN-179): collection page behaviours on top of Enterprise's facet-filters.js.
 * - Links marked .js-komto-filter-link (chips, Clear all, type tiles, finish rail, the sidebar Type
 *   group) update the grid in place through facet-filters' applyFilters. A type tile changes the
 *   tag path (/collections/shoe-storage/shoe_bench), so the path is pushed first; the colour, price
 *   and stock filters in the query stay (data-komto-keep-query). On a subcategory the type tiles lead
 *   to its category (data-komto-cross): another page, so it loads in full, with the same query kept.
 * - Type tiles in product-type mode (small collections) filter the cards already on the page.
 * - The 3 / 4 per row switch; Hide filters switches the grid to 4 columns, Show filters back to 3.
 * - Height ranges (komto-height-ranges): ticking a range ticks its hidden height_* inputs, so the form
 *   sends every tag of the range and facet-filters.js applies them (values of one filter are ORed).
 * - Read more on the SEO text.
 * - Room pages: one finish rail filters every group, and every card shows the chosen finish;
 *   "Add all to basket" on Shop the look.
 * Without JavaScript every link is a normal page load.
 */
(() => {
  if (window.komtoCollectionReady) return;
  window.komtoCollectionReady = true;

  const facets = () => document.querySelector('facet-filters');

  // Capture phase: the hidden inputs are set before facet-filters.js reads the form
  document.addEventListener('input', (event) => {
    const range = event.target.closest('[data-komto-height-range]');
    if (!range) return;
    range.closest('li').querySelectorAll('[data-komto-height-member]').forEach((member) => {
      member.checked = range.checked;
    });
  }, true);
  const grid = () => document.querySelector('.komto-grid-wrap');

  const navigate = (href, keepQuery, cross) => {
    const url = new URL(href, window.location.origin);
    if (keepQuery) {
      const current = new URLSearchParams(window.location.search);
      current.forEach((value, key) => {
        if (key !== 'page' && !url.searchParams.getAll(key).includes(value)) url.searchParams.append(key, value);
      });
    }
    const filters = facets();
    if (cross || !filters || typeof filters.applyFilters !== 'function') {
      window.location.href = url.toString();
      return;
    }
    const params = url.searchParams.toString();
    const target = `${url.pathname}${params ? `?${params}` : ''}`;
    if (target !== `${window.location.pathname}${window.location.search}`) {
      window.history.pushState({ searchParams: params }, '', target);
    }
    filters.applyFilters(params, null, false);
  };

  const filterByType = (link) => {
    const type = link.dataset.komtoType;
    // A tile with a collection lists its products by id (language-independent); otherwise match the type
    const ids = link.dataset.komtoIds !== undefined ? link.dataset.komtoIds.split(',').filter(Boolean) : null;
    const results = document.querySelectorAll('.komto-grid > .js-pagination-result');
    results.forEach((item) => {
      const card = item.querySelector('[data-product-type]');
      if (!card) {
        item.hidden = Boolean(type);
        return;
      }
      const match = ids ? ids.includes(card.dataset.productId) : card.dataset.productType === type;
      item.hidden = Boolean(type) && !match;
    });
    link.closest('.komto-types').querySelectorAll('.komto-type').forEach((tile) => {
      if (tile === link) tile.setAttribute('aria-current', 'true');
      else tile.removeAttribute('aria-current');
    });
    const shown = Array.from(results).filter((item) => !item.hidden && item.querySelector('[data-product-type]')).length;
    const count = document.querySelector('.komto-toolbar__count');
    if (count && count.dataset.other) count.textContent = shown === 1 ? count.dataset.one : count.dataset.other.replace('2', shown);
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.js-komto-filter-link');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;
    const tiles = link.closest('.komto-types');
    if (tiles && link.hasAttribute('data-komto-type') && tiles.querySelector('[data-komto-type]:not([data-komto-type=""])')) {
      event.preventDefault();
      filterByType(link);
      return;
    }
    event.preventDefault();
    navigate(link.getAttribute('href'), link.hasAttribute('data-komto-keep-query'), link.hasAttribute('data-komto-cross'));
  });

  // Density: 3 / 4 per row. The choice is remembered for the visit.
  const setCols = (cols, remember) => {
    const wrap = grid();
    if (!wrap) return;
    wrap.dataset.komtoCols = cols;
    document.querySelectorAll('.komto-density__btn').forEach((btn) => {
      btn.setAttribute('aria-pressed', btn.dataset.komtoCols === String(cols) ? 'true' : 'false');
    });
    if (remember) {
      try {
        sessionStorage.setItem('komto-cols', cols);
      } catch (e) {
        /* storage blocked: the switch still works for this page */
      }
    }
  };
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.komto-density__btn');
    if (btn) setCols(btn.dataset.komtoCols, true);
    const toggle = event.target.closest('.komto-toolbar .js-toggle-filters');
    if (toggle && window.matchMedia('(min-width: 1024px)').matches) {
      // products-toolbar.js flips is-active first; read it on the next frame
      requestAnimationFrame(() => setCols(toggle.classList.contains('is-active') ? 3 : 4, false));
    }
  });
  const initCols = () => {
    const wrap = grid();
    if (!wrap) return;
    let cols = wrap.dataset.komtoCols;
    try {
      cols = sessionStorage.getItem('komto-cols') || cols;
    } catch (e) {
      /* ignore */
    }
    setCols(cols, false);
  };
  initCols();
  document.addEventListener('on:facet-filters:updated', initCols);

  // SEO text: Read more / Show less. The rest of the text is visible until this script runs.
  document.querySelectorAll('[data-komto-readmore]').forEach((btn) => {
    const box = document.getElementById(btn.getAttribute('aria-controls'));
    if (!box) return;
    box.hidden = true;
    btn.hidden = false;
  });
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-komto-readmore]');
    if (!btn) return;
    const box = document.getElementById(btn.getAttribute('aria-controls'));
    if (!box) return;
    const open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    box.hidden = !open;
    btn.textContent = open ? btn.dataset.less : btn.dataset.more;
  });

  // Room pages (C-22): one finish filters every group; each group shows its first cards in that finish
  const room = document.querySelector('[data-komto-room]');
  if (room) {
    const limitOf = () => 4;

    // Each card follows the chosen finish (owner fix 13): that finish's photo (no hover photo), price,
    // links (?variant=), marked dot and stock note, from the card's data-komto-card-finishes.
    // "All" puts the card back as it was rendered.
    const cardWidths = [320, 460, 600, 700, 800, 900];
    const originals = new WeakMap();
    const setCardFinish = (card, fin) => {
      let finishes = [];
      try {
        finishes = JSON.parse(card.dataset.komtoCardFinishes || '[]');
      } catch (e) {
        return;
      }
      const entry = fin ? finishes.find((f) => f.k === fin) : null;
      const img = card.querySelector('.card__main-image');
      const media = card.querySelector('.komto-card__media');
      const price = card.querySelector('.komto-card__price');
      const note = card.querySelector('[data-komto-card-note]');
      const links = Array.from(card.querySelectorAll('a.js-prod-link, a.komto-card__plus--link, a.komto-card__cta'));
      const quick = Array.from(card.querySelectorAll('.js-quick-add'));
      if (!originals.has(card)) {
        originals.set(card, {
          src: img && img.getAttribute('src'),
          srcset: img && img.getAttribute('srcset'),
          alt: img && img.alt,
          hover: Boolean(media && media.classList.contains('has-hover-image')),
          price: price && price.innerHTML,
          note: note && note.textContent,
          noteHidden: note ? note.hidden : true,
          hrefs: links.map((a) => a.getAttribute('href')),
          quick: quick.map((btn) => [btn.dataset.productUrl, btn.dataset.selectedColor])
        });
      }
      const was = originals.get(card);
      if (!entry) {
        if (img && was.src) {
          img.setAttribute('src', was.src);
          if (was.srcset) img.setAttribute('srcset', was.srcset);
          img.alt = was.alt;
        }
        if (media) media.classList.toggle('has-hover-image', was.hover);
        if (price) price.innerHTML = was.price;
        if (note) {
          note.textContent = was.note;
          note.hidden = was.noteHidden;
        }
        links.forEach((a, i) => a.setAttribute('href', was.hrefs[i]));
        quick.forEach((btn, i) => {
          [btn.dataset.productUrl] = was.quick[i];
          if (was.quick[i][1]) btn.dataset.selectedColor = was.quick[i][1];
          else delete btn.dataset.selectedColor;
        });
      } else {
        if (img && entry.img) {
          img.setAttribute('src', entry.img);
          img.setAttribute('srcset', cardWidths.map((w) => `${entry.img.replace(/([?&]width=)\d+/, `$1${w}`)} ${w}w`).join(', '));
          img.alt = entry.alt;
        }
        if (media) media.classList.remove('has-hover-image');
        if (price) {
          price.textContent = '';
          const now = document.createElement('span');
          now.className = `komto-card__price-now${entry.c ? ' is-sale' : ''}`;
          now.innerHTML = entry.p;
          price.append(now);
          if (entry.c) {
            const old = document.createElement('s');
            old.className = 'komto-card__price-was';
            const label = document.createElement('span');
            label.className = 'visually-hidden';
            label.textContent = price.dataset.komtoWasLabel || '';
            old.append(label);
            old.insertAdjacentHTML('beforeend', entry.c);
            price.append(' ', old);
          }
        }
        if (note) {
          note.textContent = entry.note;
          note.hidden = !entry.note;
        }
        links.forEach((a) => a.setAttribute('href', entry.u));
        quick.forEach((btn) => {
          btn.dataset.productUrl = entry.u;
          btn.dataset.selectedColor = entry.n;
        });
      }
      card.querySelectorAll('.komto-card__dot').forEach((dot) => {
        dot.classList.toggle('is-active', Boolean(entry) && dot.dataset.swatch === entry.k.replace(/"/g, ''));
      });
    };

    const applyFinish = (fin) => {
      let total = 0;
      room.querySelectorAll('[data-komto-room-group]').forEach((group) => {
        let shown = 0;
        let matched = 0;
        group.querySelectorAll('[data-komto-fins]').forEach((item) => {
          const ok = !fin || item.dataset.komtoFins.includes(`|${fin}|`);
          if (ok) matched += 1;
          item.hidden = !ok || shown >= limitOf();
          if (ok && shown < limitOf()) shown += 1;
          const card = item.querySelector('[data-komto-card-finishes]');
          if (card && (ok || !fin)) setCardFinish(card, fin);
        });
        total += matched;
        const empty = group.querySelector('[data-komto-room-empty]');
        if (empty) empty.hidden = matched > 0;
        const all = group.querySelector('.komto-room__all');
        const label = group.querySelector('[data-komto-see-all-label]');
        if (all && label) label.textContent = matched === 1 ? all.dataset.one : all.dataset.other.replace('2', matched);
      });
      const count = room.querySelector('[data-komto-room-count]');
      if (count) count.textContent = total === 1 ? count.dataset.one : count.dataset.other.replace('2', total);
      const current = room.querySelector('[data-komto-room-current]');
      const pressed = room.querySelector(`[data-komto-fin="${CSS.escape(fin)}"]`);
      if (current) current.textContent = fin && pressed ? pressed.innerText.trim() : current.dataset.all;
      room.querySelectorAll('[data-komto-fin]').forEach((btn) => btn.setAttribute('aria-pressed', btn === pressed ? 'true' : 'false'));
    };
    room.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-komto-fin]');
      if (btn) applyFinish(btn.dataset.komtoFin);
    });
    applyFinish('');
  }

  // Shop the look (C-21): add the first available variant of every product in the look
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-komto-add-all]');
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    const status = btn.parentElement.querySelector('.komto-look__status');
    const ids = (btn.dataset.variants || '').split(',').filter(Boolean);
    if (!ids.length) return;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');
    const drawer = document.querySelector('cart-drawer');
    const sections = ['cart-icon-bubble'];
    if (drawer && drawer.closest('.shopify-section')) sections.push(drawer.closest('.shopify-section').id.replace('shopify-section-', ''));
    try {
      const response = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })), sections: sections.join(','), sections_url: window.location.pathname })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || response.status);
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections && data.sections['cart-icon-bubble']) bubble.innerHTML = data.sections['cart-icon-bubble'];
      if (status) status.textContent = btn.dataset.added;
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) drawer.renderContents({ sections: data.sections }, true);
    } catch (error) {
      if (status) status.textContent = btn.dataset.error;
    } finally {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('is-loading');
    }
  });
})();

/* KOMTO (BAN-179): on phones the subcategory chip row shows the active chip (it could sit cut off at the right edge) */
(() => {
  const show = () => document.querySelectorAll('.komto-types').forEach((nav) => {
    const active = nav.querySelector('.komto-type[aria-current="true"]');
    if (!active) return;
    for (let el = active.parentElement; el && el !== nav.parentElement; el = el.parentElement) {
      if (el.scrollWidth > el.clientWidth + 1 && getComputedStyle(el).overflowX !== 'visible') {
        const left = active.getBoundingClientRect().left - el.getBoundingClientRect().left + el.scrollLeft;
        el.scrollLeft = Math.max(0, left - (el.clientWidth - active.offsetWidth) / 2);
        break;
      }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', show); else show();
})();
